import React from 'react'
import { MainOtros, GeneralCont,ClientesContainer,OtrosClientes, CarContainer } from '../Carrusel/OtrosP.style'
import Carousel from '../../../components/Carousel/Carousel'



export default function OtrosP(props) {
    return (
        <div>
        <MainOtros>
        <GeneralCont>
            <h3>Nuestros Clientes</h3>
            <ClientesContainer>
                <OtrosClientes>
                <img href="WakkamoleMK logo" src='https://res.cloudinary.com/dojodevs/image/upload/v1581746373/smartia/RECURSOS/Wakamole-04_mj756p.png'/>
                <p>"Diseño de estrategia comercial basado en patrones de consumo a través de herramientas de Big Data y Aprendizaje de Máquina para empresas minoristas y de medios de pago."</p>
                </OtrosClientes>
                <OtrosClientes>
                <img href="VeryW logo" src='https://res.cloudinary.com/dojodevs/image/upload/v1581746728/smartia/RECURSOS/VeryW-04_g9hnje.png'/>
                <p>"Desarrollo de modelos de inteligencia artificial y analítica avanzada en banca comercial para determinar propensión de aceptación de crédito personal y empresariaLl"</p>
                </OtrosClientes>
                <OtrosClientes>
                <img href="YaVan logo" src='https://res.cloudinary.com/dojodevs/image/upload/v1581746936/smartia/RECURSOS/YaVan-04_sjxva5.png'/>
                <p>"Marketplace que centraliza el mercado de transporte privado para cotizar, comparar y contratar viajes."</p> 
                </OtrosClientes>
            </ClientesContainer>
            <CarContainer>
                <Carousel/>
            </CarContainer>
        </GeneralCont>
        </MainOtros>
        </div>
    )
}
